import React, { useEffect, useState } from 'react';
import SuperadminLayout from '../../components/SuperadminLayout';
import { getSiteNotice, updateSiteNotice } from '../../api/siteNotice';
import './SuperadminAvisPage.css';

const FIELDS = [
  { key: 'subtitle', label: 'Sous-titre', type: 'text' },
  { key: 'center1_name', label: 'Centre 1 — nom', type: 'text' },
  { key: 'center1_lines', label: 'Centre 1 — adresse (une ligne par ligne)', type: 'area' },
  { key: 'center2_name', label: 'Centre 2 — nom', type: 'text' },
  { key: 'center2_lines', label: 'Centre 2 — adresse', type: 'area' },
  { key: 'extra_lines', label: 'Contacts supplémentaires', type: 'area' },
  { key: 'announcement', label: 'Annonce (surbrillance jaune)', type: 'area' },
  { key: 'footer', label: 'Pied de page', type: 'text' },
];

const SuperadminAvisPage = () => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    getSiteNotice().then(setForm).catch(() => setError('Chargement impossible.'));
  }, []);

  const set = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMsg('');
    setError('');
    try {
      const saved = await updateSiteNotice(form);
      setForm(saved);
      setMsg('Enregistré.');
    } catch (err) {
      setError('Enregistrement impossible.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <SuperadminLayout>
      <h2 className="savi-title">Avis (bloc affiché dans le portail company)</h2>

      {error && <p className="savi-error">{error}</p>}
      {!form ? <p>Chargement…</p> : (
        <form className="savi-form" onSubmit={handleSubmit}>
          {FIELDS.map((f) => (
            <div key={f.key} className="savi-row">
              <label className="savi-label">{f.label}</label>
              {f.type === 'area' ? (
                <textarea
                  className="savi-input savi-area"
                  rows={4}
                  value={form[f.key] || ''}
                  onChange={(e) => set(f.key, e.target.value)}
                />
              ) : (
                <input
                  className="savi-input"
                  type="text"
                  value={form[f.key] || ''}
                  onChange={(e) => set(f.key, e.target.value)}
                />
              )}
            </div>
          ))}

          <label className="savi-checkbox">
            <input
              type="checkbox"
              checked={!!form.announcement_enabled}
              onChange={(e) => set('announcement_enabled', e.target.checked)}
            />
            Afficher l'annonce jaune
          </label>

          {msg && <p className="savi-ok">{msg}</p>}
          {error && <p className="savi-error">{error}</p>}

          <button type="submit" className="savi-btn" disabled={saving}>
            {saving ? 'Enregistrement…' : 'Enregistrer'}
          </button>
        </form>
      )}
    </SuperadminLayout>
  );
};

export default SuperadminAvisPage;
